var map = {
	"./long-01.png": 2125,
	"./long-02.png": 2126,
	"./long-03.png": 2127,
	"./long-04.png": 2128,
	"./long-05.png": 2129,
	"./long-06.png": 2130,
	"./long-07.png": 2131,
	"./long-08.png": 2132,
	"./long-09.png": 2133,
	"./long-10.png": 2134,
	"./long-11.png": 2135,
	"./long-12.png": 2136,
	"./long-13.png": 2137,
	"./long-14.png": 2138,
	"./long-15.png": 2139,
	"./long-16.png": 2140,
	"./long-17.png": 2141,
	"./long-18.png": 2142,
	"./long-19.png": 2143,
	"./long-20.png": 2144,
	"./long-21.png": 2145,
	"./long-22.png": 2146,
	"./long-23.png": 2147,
	"./long-24.png": 2148,
	"./long-25.png": 2149,
	"./long-26.png": 2150,
	"./long-27.png": 2151,
	"./long-28.png": 2152,
	"./long-29.png": 2153,
	"./long-30.png": 2154,
	"./long-31.png": 2155
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2124;


//////////////////
// WEBPACK FOOTER
// ./src/images/pitch-deck/long ^\.\/.*$
// module id = 2124
// module chunks = 0